// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"PlantDropdownSelector_dropdown__2jkdc","dropdownDark":"PlantDropdownSelector_dropdownDark__10MtS"};